import loadable from '@loadable/component';
import React from 'react';

import Spin from '../spin/spin';

export const ProblemLoadable = loadable(
    //@ts-ignore
    () => import(/* webpackChunkName: "problem" */ '../problem/problem'),
    { fallback: <Spin center /> }
);
